module.exports = __webpack_public_path__ + "static/media/firstScreenBackground.de092b31.png";